// import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAvailabilityTableData, AVAILABILITY_POLLING_INTERVAL } from '../services/api';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

// const PORTS = [
//   { key: 'Charleston', name: 'Charleston, SC' },
//   { key: 'Houston', name: 'Houston, TX' },
//   { key: 'Norfolk', name: 'Norfolk, VA' },
//   { key: 'Savannah', name: 'Savannah, GA' }
// ];

interface AvailabilityCalendarProps {
  selectedPort: string | null;
}

export const AvailabilityCalendar: React.FC<AvailabilityCalendarProps> = ({ selectedPort }) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['availabilityTable'],
    queryFn: getAvailabilityTableData,
    refetchInterval: AVAILABILITY_POLLING_INTERVAL,
    refetchIntervalInBackground: true,
  });

  // const filteredData = selectedPort
  //   ? data?.data.filter((entry: any) => entry.terminalKey === selectedPort)
  //   : [];

    const filteredData = selectedPort
  ? data?.data
      .filter((entry: any) => entry.terminalKey === selectedPort)
      .slice(0, 4)
  : [];


  // const calculateAvailableSpots = (weekStartDate: number, driverCount: number, shipmentCount: number) => {
  //   const maxSpots = Math.floor(((driverCount - 1) * 0.9) * 5);
  //   return Math.max(0, maxSpots - shipmentCount);
  // };

  // const getHolidayDate = (year: number, month: number, day: number, ordinal?: number, weekday?: number): Date => {
  //   // For fixed date holidays
  //   if (!ordinal && !weekday) {
  //     const holiday = new Date(year, month - 1, day);
  //     const dayOfWeek = holiday.getDay();
      
  //     // Saturday (6) -> Friday, Sunday (0) -> Monday
  //     if (dayOfWeek === 6) return new Date(year, month - 1, day - 1);
  //     if (dayOfWeek === 0) return new Date(year, month - 1, day + 1);
  //     return holiday;
  //   }
    
  //   // For floating holidays (like nth Monday of month)
  //   if (ordinal && weekday) {
  //     const firstDay = new Date(year, month - 1, 1);
  //     const firstDayOfWeek = firstDay.getDay();
  //     let dayOffset = weekday - firstDayOfWeek;
  //     if (dayOffset < 0) dayOffset += 7;
  //     dayOffset += (ordinal - 1) * 7;
  //     return new Date(year, month - 1, 1 + dayOffset);
  //   }
    
  //   throw new Error('Invalid holiday parameters');
  // };
  
  // const isHolidayWeek = (weekStartDate: number): boolean => {
  //   const date = new Date(weekStartDate);
  //   const year = date.getFullYear();
  //   const weekStart = new Date(weekStartDate);
  //   const weekEnd = new Date(weekStartDate);
  //   weekEnd.setDate(weekEnd.getDate() + 6);
  
  //   // Array of holiday dates for the current year
  //   const holidays = [
  //     getHolidayDate(year, 1, 1), // New Year's Day
  //     getHolidayDate(year, 1, 1, 3, 1), // MLK Day (3rd Monday in January)
  //     getHolidayDate(year, 7, 4), // Independence Day
  //     getHolidayDate(year, 9, 1, 1, 1), // Labor Day (1st Monday in September)
  //     getHolidayDate(year, 11, 1, 4, 4), // Thanksgiving (4th Thursday in November)
  //     getHolidayDate(year, 12, 25), // Christmas
  //   ];
  
  //   // Check if any holiday falls within the week
  //   return holidays.some(holiday => 
  //     holiday >= weekStart && holiday <= weekEnd
  //   );
  // };
  
  // const calculateAvailableSpots = (weekStartDate: number, driverCount: number, shipmentCount: number): number => {
  //   const workDays = isHolidayWeek(weekStartDate) ? 4 : 5;
  //   const maxSpots = Math.floor(((driverCount - 1) * 0.9) * workDays);
  //   return Math.max(0, maxSpots - shipmentCount);
  // };
  
  return (
    <div className="card bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold text-primary mb-6">Availability Calendar</h2>

      {/* <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Port Selection
        </label>
        <select
          value={selectedPort || ''}
          onChange={() => {}}
          className="custom-select w-full h-12 pl-4 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary text-base"
          disabled
        >
          <option value="">Select Port</option>
          {PORTS.map(port => (
            <option key={port.key} value={port.key}>
              {port.name}
            </option>
          ))}
        </select>
      </div> */}

      {isLoading && (
        <div className="card animate-pulse">
          <div className="h-48 bg-gray-200 rounded"></div>
        </div>
      )}

      {isError && (
        <div className="card bg-red-50">
          <p className="text-red-700">
            Unable to load availability information. Please try again later.
          </p>
        </div>
      )}

      {selectedPort && (
        <div className="grid grid-cols-4 gap-4">
          {filteredData?.map(({ availableSpots, projectedDeliveryWk, weekStartDate, driverCount, shipmentCount }: any) => {
            // const availableSpots = calculateAvailableSpots(weekStartDate, driverCount, shipmentCount);
            const weekNumber = dayjs(weekStartDate).week();
            const maxSpots = Math.floor(((driverCount - 1) * 0.9) * 5);

            return (
              <div key={weekStartDate} className="bg-gray-50 rounded-lg p-4">
                <div className="text-center">
                  <div className="text-xs text-gray-500 mb-1">Week {weekNumber}</div>
                  <div className="text-sm font-medium mb-1">{dayjs(weekStartDate).format('MMM D')}</div>
                  <div className="relative pt-1">
                    <div className="flex mb-1 items-center justify-center">
                      <div className="text-xs font-semibold">
                        {availableSpots} spots left
                      </div>
                    </div>
                    <div className="overflow-hidden h-2 text-xs flex rounded bg-gray-200">
                      <div
                        style={{ width: `${(shipmentCount / maxSpots) * 100}%` }}
                        className={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center ${shipmentCount < maxSpots ? 'bg-green-500' : 'bg-red-500'}`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
